import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n/config';
// Configurar a API key do Shopify antes de renderizar o app
import './setup-app-bridge';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);














